module.exports = __webpack_public_path__ + "static/images/lotusFlower.8bfaf17cb285ce323a5e49b3b9e19a53.svg";